"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Sms {
}
exports.default = Sms;
//# sourceMappingURL=Sms.js.map